import { render, staticRenderFns } from "./EditCalendar.vue?vue&type=template&id=355f6c46&"
import script from "./EditCalendar.vue?vue&type=script&lang=js&"
export * from "./EditCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports